import { GET_TENANT_REQUEST, } from '../constants/TenantConstant'

export const getTenantById = (tenantId) => {
    return{
        type: GET_TENANT_REQUEST,
        tenantId
    }
}

